export default __webpack_public_path__ + "static/media/colors.84dd39ee.svg";